jQuery(function($) {
    $( document ).ready(function() {

        hamletServices();

        window.scrollTo(0, 0);

        function hamletServices() {
            var servicesGrid = document.querySelector('.apartment-container .hamlet-services .services-grid');
  
            if(servicesGrid) {
                var services = servicesGrid.querySelectorAll('.service');
         
                services.forEach(function(service) {
  
                    let openIcon = service.querySelector('#open-icon');
                    let closeIcon = service.querySelector('#close-icon');
    
                    openIcon.addEventListener('click' , function() {
                        
                        hamletServicesClose(services);
                        hamletServiceOpen(service , openIcon , closeIcon);
                        hamletServicesStyles(services);
    
                    })
                
                    closeIcon.addEventListener('click' , function() {
                        hamletServiceClose(service , openIcon , closeIcon);
                        hamletServicesResetStyles(services);
                    })  
              })
            }
        }
        
        // OPEN ONE SERVICE
        function hamletServiceOpen(service, openIcon, closeIcon) {
            
            let dropdown = service.querySelector('.dropdown-content');

            service.classList.add('active');
            openIcon.style.display = "none";
            closeIcon.style.display = "block";
            dropdown.classList.add('open');
        }
    
        // CLOSE ONE SERVICE
        function hamletServiceClose(service , openIcon , closeIcon) {
    
            let dropdown = service.querySelector('.dropdown-content');

            service.classList.remove('active');
            openIcon.style.display = "block";
            closeIcon.style.display = "none";
            dropdown.classList.remove('open');
        
        }
    
        // CLOSE ALL SERVICES
        function hamletServicesClose(services) {
            services.forEach(function(service) {
                let openIcon = service.querySelector('#open-icon');
                let closeIcon = service.querySelector('#close-icon');
                openIcon.style.display = "block";
                closeIcon.style.display = "none";
                service.classList.remove('active');
            })

            let dropdowns = document.querySelectorAll('.services-grid .dropdown-content');
            dropdowns.forEach(function(dropdown) {
                dropdown.classList.remove('open');
            })
            hamletServicesStyles(services);
        }
    
        // UPDATE Styles ON SERVICES 
        function hamletServicesStyles(services) {
    
            hamletServicesResetStyles(services);
    
            services.forEach(function(service) {
                let titleWrapper = service.querySelector('.title-wrapper');
                let title = titleWrapper.querySelector('h4');
                let openIcon = titleWrapper.querySelector('#open-icon');

                if(!service.classList.contains('active')) {
                    title.style.color = "black";
                    title.style.opacity = "0.6";
                    let lines = openIcon.querySelectorAll('line');
                    lines.forEach(function(line) {
                        line.style.stroke = "black";
                        line.style.opacity = "0.6";
                    })
        

                }

            })
        }
  
        // RESET ALL SERVICES COLOR
        function hamletServicesResetStyles(services) {
    
            services.forEach(function(service) {
                let titleWrapper = service.querySelector('.title-wrapper');
                let title = titleWrapper.querySelector('h4');
                let openIcon = titleWrapper.querySelector('#open-icon');
                let img = service.querySelector('img');

                // RESET COLORS
                title.style.color = "black";
                title.style.opacity = "1";
            
                let lines = openIcon.querySelectorAll('line');
                lines.forEach(function(line) {
                    line.style.stroke = "black";
                    line.style.opacity = "1";
                })
                
            })
        }

    });
});